import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import LeadScoreAPI from '../../../api/LeadScoreAPI';
import withRouter from '../../../util/WithRouter';
import Const from '../../../util/Constants';
import FieldController from '../../../controller/FieldController';
import Util from '../../../util/Util';
import ApiUiController from '../../../controller/ApiUiController';
import ScoreCondition from './ScoreCondition';

class LeadScoreUpdate extends React.Component {
  constructor(props) {
    super(props);
    const id = parseInt(props.match.params.id);
    this.state = { 
      inApiCall: this.id !== 0, 
      name: '', 
      condition: Const.AND,
      id: id,  
      description: '',
      score: 0, 
      type: 0, 
      inValid: {}, 
      users: [], 
    };
    const model = reactLocalStorage.getObject(Const.Model);
    this.model = model.lead;
    this.fields = FieldController.getFilterFields(this.model.fields);
    this.users = model.user.options;
    this.basePath = this.props.match.path;
    this.basePath = this.basePath.substring(0, this.basePath.lastIndexOf('/'));
    this.conditions = [{}];
  }

  componentDidMount() {
    if (this.state.id !== 0) {
      LeadScoreAPI.get(this.state.id, this.onReceived, this.onFail);
    }
  }

  onFail = () => this.setState({ inApiCall: false });
  onReceived = dist => {
    this.conditions = JSON.parse(dist.filters);
    this.setState({ 
      id: dist.id, 
      name: dist.rule_name, 
      condition: dist.filters,  
      description: dist.rule_description 
    });
  };

  validateField = (field, value) => {
    if (field === 'name') {
      return value.trim() === '' ? 'Rule Name is required' : null;
    }
    if (field === 'description') {
      return value.trim() === '' ? 'Rule Description is required' : null;
    }
    if (field === 'conditions') {
      return this.conditions.length === 0 ? 'At least one condition is required' : null;
    }
    return null;
  };

  handleValidation = () => {
    const inValid = {};
    ['name', 'description', 'conditions'].forEach(field => {
      const error = this.validateField(field, this.state[field]);
      if (error) inValid[field] = error;
    });
    this.setState({ inValid });
    return Object.keys(inValid).length === 0;
  };

  nameChange = event => this.setState({ name: event.target.value });
  descriptionChange = event => this.setState({ description: event.target.value });
  toggleChange = tog => this.setState({ condition: tog });
  edit = conditions => { this.conditions = conditions; };

  onSave = () => {
    if (this.handleValidation()) {
      this.setState({ inApiCall: true });
      const conditions = this.conditions.map(filter => {
        if (Object.keys(filter).length === 0) return {};
        return { 
          field: filter.field.value,
          condition: filter.condition.value, 
          value: filter.value,
          score: filter.score, 
          type: filter.type.value || filter.type,
        };
      });

      const dist = { 
        id: this.state.id, 
        name: this.state.name,
        condition_option: this.state.condition, 
        description: this.state.description, 
        action: this.state.action, 
        conditions: JSON.stringify(conditions),
      };

      LeadScoreAPI.save(dist, this.onSaved, this.onFail);
    } else {
      Util.showNotification('Form incomplete', 'Please fill all required fields', 'danger');
    }
  };

  onSaved = () => {
    Util.showNotification('Successful', 'Successfully saved.', 'success');
    this.props.navigate(this.basePath);
  };

  render() {
    const { inValid } = this.state;

    return (
      <div className="sectionform pt-4">
        <div className="container-fluid form-cont">
          <div className="row">
            <div className="col-md-12 pb-3">
              <h3>Lead Score</h3>
            </div>
          </div>

          <ApiUiController inApiCall={this.props.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              <div className="col-md-4">
                <div className="form-group">
                  <FormControl 
                    type='text' 
                    placeholder='Rule Name'
                    className={`mr-sm-2 ${inValid.name ? 'is-invalid' : ''}`}
                    value={this.state.name} 
                    onChange={this.nameChange} 
                  />
                  <div className="invalid-feedback">{inValid.name}</div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <FormControl 
                    type='text' 
                    placeholder='Rule Description'
                    className={`mr-sm-2 ${inValid.description ? 'is-invalid' : ''}`} 
                    value={this.state.description} 
                    onChange={this.descriptionChange} 
                  />
                  <div className="invalid-feedback">{inValid.description}</div>
                </div>
              </div>

              <div className="formhead col-md-12">
                <h4>Conditions</h4>
              </div>
              <ScoreCondition 
                model={this.model} 
                fields={this.fields} 
                value={this.conditions}
                eKey="conditions" 
                onConditionChanged={this.edit} 
              />
              {inValid.conditions && <div className="text-danger">{inValid.conditions}</div>}

              <div className="col-md-12 text-center btnsend">
                <Button variant="success" onClick={this.onSave}>Save</Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(LeadScoreUpdate);